/**
 * useIsDeveloper — single shared source of truth for "is the current Clerk
 * user marked as developer in privateMetadata.role".
 *
 * Backed by `/v1/chat/me/is-developer` (which reads Clerk Backend API
 * server-side, with its own 5-minute role cache). React Query caches the
 * result client-side too with a 1-hour staleTime so the sidebar / settings /
 * other developer-gated UI doesn't refetch on every route change.
 *
 * Returns false until the user is signed in or while loading — fail-closed.
 */
import { useQuery } from '@tanstack/react-query';
import { useAuth } from './useAuth';
import { fetchApi } from '../api/client';

export function useIsDeveloper(): boolean {
  const { user, getAccessToken } = useAuth();
  const userId = user?.id ?? '';

  const { data } = useQuery<{ is_developer: boolean }>({
    queryKey: ['me-is-developer', userId],
    enabled:  !!userId,
    queryFn:  () => fetchApi<{ is_developer: boolean }>('/v1/chat/me/is-developer', {}, { getToken: getAccessToken }),
    staleTime: 60 * 60 * 1000, // 1 h — Clerk role changes rarely
    retry: false,
  });

  return data?.is_developer === true;
}
